import { Play } from "react-bootstrap-icons";

interface FilePreviewItemProps {
  file: string | File;
  originalUrl: string; 
  category: "image" | "video" | "audio" | "other";
  showDelete: boolean;
  onDelete: () => void;
}

export const FilePreviewItem = ({
  file,
  originalUrl,
  category,
  showDelete,
  onDelete,
}: FilePreviewItemProps) => {
  const renderContent = () => {
    const src = typeof file === "string" ? file : URL.createObjectURL(file);

    if (category === "image") {
      return (
        <img
          src={src}
          alt="Фото"
          style={{
            width: 32,
            height: 32,
            objectFit: "cover",
            borderRadius: 6,
          }}
        />
      );
    }

    if (category === "video") {
      return (
        <>
          <video
            src={src}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: 6,
            }}
            muted
            preload="metadata"
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Play size={16} color="white" />
          </div>
        </>
      );
    }

    const ext =
      typeof file === "string"
        ? originalUrl.split(".").pop()?.toUpperCase() || "FILE"
        : file.name.split(".").pop()?.toUpperCase() || "FILE";

    return (
      <div
        style={{
          padding: "4px 8px",
          background: "#dee2e6",
          borderRadius: 4,
          fontSize: 12,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
        }}
      >
        {ext}
      </div>
    );
  };

  return (
    <div
      key={originalUrl}
      style={{
        position: "relative",
        marginLeft: 8,
        width: category === "other" ? "auto" : 32,
        height: category === "other" ? "auto" : 32,
        borderRadius: 6,
        backgroundColor: category === "video" ? "#000" : "transparent",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
      }}
    >
      {renderContent()}
      {showDelete && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          style={{
            position: "absolute",
            top: -3,
            right: -3,
            background: "#dc3545",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: 10,
            height: 10,
            fontSize: 7,
            cursor: "pointer",
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};